/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Slider/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Slider({
  children,
  viewPath = "/DesignSystem/Slider",
  width = "100%",
  flexGrow,
  flexShrink,
  flexBasis,
  backgroundColor = "#f2f2f2",
  type = "range",
  height = 8,
  min = 0,
  max = 100,
  step = 1,
  value = 50,
  className,
  disabled,
  onChange,
  onInput,
  marginRight,
  marginLeft,
  marginTop = 16,
  marginBottom = 0,
  borderBottomLeftRadius = 4,
  borderBottomRightRadius = 4,
  borderTopLeftRadius = 4,
  borderTopRightRadius = 4,
  showMinMaxLabel,
  minFormatted,
  maxFormatted
  
}) {
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Slider.Vertical"
  data-view-path={viewPath}
 style={{'--w-1-Z298GJN': typeof width === 'number' ? `${width}px` : width,'--fg-2-Z298GJN': flexGrow,'--fs-3-Z298GJN': flexShrink,'--fb-4-Z298GJN': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis}}
 className={`views-block ${styles.Vertical}`}
>
<input
 type={
                type === 'phone' ? 'tel' :
                type === 'secure' ? 'password' : type}
inputMode={type === 'number' || type === 'phone'? "numeric" : undefined}
pattern={type === 'number' || type === 'phone'? "[0-9]*" : undefined}
  data-testid="Slider.Input"
  data-view-path={viewPath}
 min={min}
 max={max}
 step={step}
 value={value}
 disabled={disabled}
 onChange={(e) => onChange && onChange(e, e.target.value)}
 onInput={onInput}
 style={{'--bc-5-Z298GJN': backgroundColor,'--w-1-Z298GJN': typeof width === 'number' ? `${width}px` : width,'--h-6-Z298GJN': typeof height === 'number' ? `${height}px` : height,'--mr-7-Z298GJN': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-8-Z298GJN': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mt-9-Z298GJN': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-10-Z298GJN': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--bblr-11-Z298GJN': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-12-Z298GJN': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-13-Z298GJN': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-14-Z298GJN': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius}}
 className={`views-capture ${className} ${styles.Input}`}
/>
<fromFlow.When is={showMinMaxLabel}>
<div
  data-testid="Slider.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-8-Z298GJN': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-7-Z298GJN': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-9-Z298GJN': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtSpaceLs}
 color={dtColorsNeutral600}
 text={minFormatted}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtSpaceLs}
 color={dtColorsNeutral600}
 text={maxFormatted}
/>
</div>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}